"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("utils");
var combineLearningPanelFreeUrl = function (url) { return "".concat((0, utils_1.getPlatformUrl)(), "/learning_panel_free").concat(url); };
exports.default = combineLearningPanelFreeUrl;
